import { render, staticRenderFns } from "./CategoryButton.vue?vue&type=template&id=c1c8cece&"
import script from "./CategoryButton.vue?vue&type=script&lang=js&"
export * from "./CategoryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports